import './styles/App.css';
import Coin from "./Coin";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Coin />
      </header>
    </div>
  );
}

export default App;
